import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { WsService } from '../ws/ws.service';

@Component({
  selector: 'app-docs',
  templateUrl: './docs.component.html',
  styleUrls: ['./docs.component.scss']
})
export class DocsComponent implements OnInit, OnDestroy {

  private userSubscription: Subscription;
  private connectSubscription: Subscription;
  private docsSubscription: Subscription;
  private docAcceptSubscription: Subscription;
  private docPending: any;
  public user: any;
  public docs: any;
  public readLocked: boolean;

  constructor(private ws: WsService) {
      this.userSubscription = this.ws.onUser.subscribe(this.onChangeUser.bind(this));
      this.docsSubscription = this.ws.events.doc_list.subscribe(this.onDocs.bind(this));
      this.docAcceptSubscription = this.ws.events.doc_accept.subscribe(this.onDocAccepted.bind(this));
      this.connectSubscription = this.ws.onConnect.subscribe(this.onConnect.bind(this));
      this.user = this.ws.getUser();
      this.readLocked = false;
  };

  private onChangeUser(user: any): void {
      this.user = user;
      this.initDocs();
  };

  private initDocs(): void {
      this.docs = [];
      this.docPending = null;
      if (this.user) {
          this.ws.methodListDocs();
      }
  };

  private onDocs(data: any): void {
      this.docs = [];
      if (this.user && data.attachments) {
          this.docs = data.attachments.map(this.preProcessDoc.bind(this));
      }
  };

  private onConnect(): void {
      this.readLocked = false;
  };

  private onDocAccepted(): void {
      this.readLocked = false;
      if (this.docPending) {
          this.docPending.DT_ACCEPT = this.formatServerDateTime(new Date());
          this.docPending = null;
      }
  };

  private preProcessDoc(doc: any): any {
      if (!doc) {
          return doc;
      }
      doc.id = doc.ID;
      doc.path = '/download_documents/' + this.isoDate(doc.DT_UPLOAD) + '/' + doc.ID +  '/' + doc.FILENAME;
      return doc;
  };

  private isoDate(dateStr: string): string {
      return dateStr.substr(6, 4) + dateStr.substr(3, 2) + dateStr.substr(0, 2);
  }

  private formatServerDateTime(d: any): any {
      if (!d || !d.toISOString) {
          return '';
      }
      const isoString = new Date(d.valueOf() - d.getTimezoneOffset() * 60000).toISOString();
      return isoString.substring(8, 10) + '.' + isoString.substring(5, 7) + '.' + isoString.substring(0, 4) + ' ' + isoString.substring(11, 19);
  };

  private parseServerDate(d: any): any {
      if (!d) {
          return '';
      }
      // 11.02.2020 1:00:00
      const dateFields = d.split(/[\. :]/);
      let isoDate =  dateFields[2] + '-' + dateFields[1].padStart(2, '0') + '-' + dateFields[0].padStart(2, '0');
      if (dateFields.length > 3) {
          isoDate += ' ' + dateFields[3].padStart(2, '0') + ':' + dateFields[4].padStart(2, '0') + ':' + dateFields[5].padStart(2, '0') + 'Z';
      } else {
          isoDate += ' 00:00:00';
      } 
      return isoDate;
  };

  public readDoc(doc: any): void {
      if (!this.readLocked && doc) {
          this.readLocked = true;
          this.docPending = doc;
          this.ws.methodDocAccept(doc.id);
      }
  };

  public downloadDoc(doc: any): void {
      if (doc) {
          doc.DT_DOWNLOAD = this.formatServerDateTime(new Date());
      }
  };

  ngOnInit() {
      this.initDocs();
  };

  ngOnDestroy() {
      this.userSubscription.unsubscribe();
      this.docsSubscription.unsubscribe();
      this.docAcceptSubscription.unsubscribe();
      this.connectSubscription.unsubscribe();
  };

}



// WEBPACK FOOTER //
// ./src/app/docs/docs.component.ts